module.exports = __webpack_public_path__ + "static/media/img53.a557b859.jpg";